module.exports = "<ul class=\"tabs-left filters\"><span *ngFor=\"let key of this.keys; index as i;\"><li *ngIf=\"this.tabs[key].value &amp;&amp; this.tabs[key].value.length &gt; 0\" id=\"{{ key }}\">{{ key}}<span *ngFor=\"let tag of this.tabs[key].value; index as i\"><p class=\"filterItem \" *ngIf=\"tag\" id=\"{{key}}:{{tag}}\">&#x25BA; {{ tag }}</p></span></li></span></ul>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/app-filter-tabs/app-filter-tabs.component.pug
// module id = 1166
// module chunks = 1